<template>
  <section class="relative bg-gradient-to-b from-gray-900 via-gray-900 to-black py-20 text-white">
    <div class="container mx-auto px-4">
      <div class="flex flex-col items-center text-center" v-scroll-reveal="{ delay: 0.1 }">
        <p class="text-sm uppercase tracking-[0.6em] text-amber-400">Contact</p>
        <h2 class="mt-4 text-4xl font-bold lg:text-5xl">We’re here 24/7 for your Umrah planning</h2>
        <p class="mt-4 max-w-3xl text-gray-300">
          Message us for package customization, visa updates, transport bookings, or any special requests. Our consultants respond
          within minutes over phone, email, or WhatsApp.
        </p>
      </div>

    <div class="mt-12 grid gap-10 lg:grid-cols-2">
        <div class="space-y-6" v-scroll-reveal="{ delay: 0.2 }">
          <div class="rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur flex flex-col h-full">
            <h3 class="text-2xl font-semibold mb-6">Contact Details</h3>
            <div class="space-y-4 text-sm text-gray-300 flex-1">
              <div class="flex items-center gap-3">
                <div class="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/10 text-amber-400 flex-shrink-0">
                  <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <p class="text-xs uppercase tracking-[0.4em] text-amber-400">Phone</p>
                  <p class="text-base text-white">+92 318 5073318</p>
                </div>
              </div>
              <div class="flex items-center gap-3">
                <div class="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/10 text-amber-400 flex-shrink-0">
                  <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p class="text-xs uppercase tracking-[0.4em] text-amber-400">Email</p>
                  <p class="text-base text-white">aletimadtravel@gmail.com</p>
                </div>
              </div>
              <div class="flex items-center gap-3">
                <div class="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/10 text-amber-400 flex-shrink-0">
                  <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  </svg>
                </div>
                <div>
                  <p class="text-xs uppercase tracking-[0.4em] text-amber-400">Office</p>
                  <p class="text-base text-white">Al Etimad Office, Street 14, Kehkashan Colony, Adyala Road, Rawalpindi, Pakistan</p>
                </div>
              </div>
            </div>

           

            <!-- Additional content to match form height -->
            <div class="mt-8 pt-6 border-t border-white/10">
              <p class="text-sm text-gray-400 leading-relaxed">
                We're available 24/7 to assist you with your Umrah journey. Whether you need help with package customization, visa processing, or have any special requests, our dedicated team is here to help.
              </p>
              <p class="text-sm text-gray-400 leading-relaxed mt-4">
                Visit our office during business hours or reach out via phone, email, or WhatsApp for immediate assistance.
              </p>
            </div>
          </div>
        </div>

        <form @submit.prevent="handleSubmit" class="rounded-[32px] border border-white/10 bg-white/5 p-8 backdrop-blur h-full flex flex-col" v-scroll-reveal="{ delay: 0.25 }">
          <div class="grid gap-4 md:grid-cols-2">
            <div>
              <label class="text-xs uppercase tracking-wide text-gray-300">Full Name</label>
              <input 
                v-model="formData.fullName" 
                type="text" 
                placeholder="Muhammad Ali" 
                :class="['mt-2 w-full rounded-2xl border bg-black/20 px-4 py-3 text-sm text-white focus:outline-none', errors.fullName ? 'border-red-400 focus:border-red-400' : 'border-white/10 focus:border-amber-400']"
                @blur="validateField('fullName')"
              />
              <p v-if="errors.fullName" class="mt-1 text-xs text-red-400">{{ errors.fullName }}</p>
            </div>
            <div>
              <label class="text-xs uppercase tracking-wide text-gray-300">Email</label>
              <input 
                v-model="formData.email" 
                type="email" 
                placeholder="you@example.com" 
                :class="['mt-2 w-full rounded-2xl border bg-black/20 px-4 py-3 text-sm text-white focus:outline-none', errors.email ? 'border-red-400 focus:border-red-400' : 'border-white/10 focus:border-amber-400']"
                @blur="validateField('email')"
              />
              <p v-if="errors.email" class="mt-1 text-xs text-red-400">{{ errors.email }}</p>
            </div>
          </div>
          <div class="mt-4">
            <label class="text-xs uppercase tracking-wide text-gray-300">Phone / WhatsApp</label>
            <input 
              v-model="formData.phone" 
              type="text" 
              placeholder="+01 234 567 890" 
              :class="['mt-2 w-full rounded-2xl border bg-black/20 px-4 py-3 text-sm text-white focus:outline-none', errors.phone ? 'border-red-400 focus:border-red-400' : 'border-white/10 focus:border-amber-400']"
              @blur="validateField('phone')"
            />
            <p v-if="errors.phone" class="mt-1 text-xs text-red-400">{{ errors.phone }}</p>
          </div>
          <div class="mt-4">
            <label class="text-xs uppercase tracking-wide text-gray-300">Message</label>
            <textarea 
              v-model="formData.message" 
              rows="4" 
              placeholder="Tell us about your plans..." 
              :class="['mt-2 w-full rounded-2xl border bg-black/20 px-4 py-3 text-sm text-white focus:outline-none', errors.message ? 'border-red-400 focus:border-red-400' : 'border-white/10 focus:border-amber-400']"
              @blur="validateField('message')"
            ></textarea>
            <p v-if="errors.message" class="mt-1 text-xs text-red-400">{{ errors.message }}</p>
          </div>
          <button type="submit" class="mt-6 w-full rounded-2xl bg-amber-500 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-amber-600">
            Send Message
          </button>
        </form>
      </div>
    </div>

    <a
      :href="whatsappLink"
      target="_blank"
      rel="noreferrer"
      class="fixed bottom-8 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-green-500 text-white shadow-2xl transition-all hover:bg-green-600 hover:scale-110 hover:shadow-green-500/50"
      aria-label="Contact us on WhatsApp"
    >
      <svg class="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
      </svg>
    </a>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      
      whatsappNumber: '+92 318 5073318',
      formData: {
        fullName: '',
        email: '',
        phone: '',
        message: ''
      },
      errors: {
        fullName: '',
        email: '',
        phone: '',
        message: ''
      }
    }
  },
  computed: {
    whatsappLink() {
      return `https://wa.me/${this.whatsappNumber.replace(/[^0-9]/g, '')}`
    }
  },
  methods: {
    validateField(fieldName) {
      this.errors[fieldName] = ''
      
      switch (fieldName) {
        case 'fullName':
          if (!this.formData.fullName || this.formData.fullName.trim() === '') {
            this.errors.fullName = 'Full name is required'
          }
          break
        case 'email':
          if (!this.formData.email || this.formData.email.trim() === '') {
            this.errors.email = 'Email is required'
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
            this.errors.email = 'Please enter a valid email address'
          }
          break
        case 'phone':
          if (!this.formData.phone || this.formData.phone.trim() === '') {
            this.errors.phone = 'Phone number is required'
          } else if (this.formData.phone.trim().length < 10) {
            this.errors.phone = 'Please enter a valid phone number'
          }
          break
        case 'message':
          if (!this.formData.message || this.formData.message.trim() === '') {
            this.errors.message = 'Message is required'
          }
          break
      }
    },
    validateForm() {
      // Validate all fields
      this.validateField('fullName')
      this.validateField('email')
      this.validateField('phone')
      this.validateField('message')
      
      // Check if there are any errors
      return !Object.values(this.errors).some(error => error !== '')
    },
    handleSubmit() {
      // Validate form before submission
      if (!this.validateForm()) {
        return
      }

      // Build WhatsApp message with form data
      const message = `*Contact Form Submission*\n\n` +
        `*Full Name:* ${this.formData.fullName}\n` +
        `*Email:* ${this.formData.email}\n` +
        `*Phone/WhatsApp:* ${this.formData.phone}\n` +
        `*Message:*\n${this.formData.message}`

      // Encode the message
      const encodedMessage = encodeURIComponent(message)

      // Clean the WhatsApp number
      const cleanNumber = this.whatsappNumber.replace(/[^0-9]/g, '')

      // Build WhatsApp URL
      const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodedMessage}`

      // Open WhatsApp in new tab
      window.open(whatsappUrl, '_blank')

      // Reset form after submission
      this.formData = {
        fullName: '',
        email: '',
        phone: '',
        message: ''
      }
      this.errors = {
        fullName: '',
        email: '',
        phone: '',
        message: ''
      }
    }
  }
}
</script>

